<div class="flex items-center justify-center h-full" [ngClass]="{'min-h-screen':!disablescreenheight}">
    <div class="flex my-6 justify-center items-center"><div class="lds-ripple"><div></div><div></div></div></div>
</div>